import { render, staticRenderFns } from "./coursewareTimeOut.vue?vue&type=template&id=326d5000&"
import script from "./coursewareTimeOut.vue?vue&type=script&lang=js&"
export * from "./coursewareTimeOut.vue?vue&type=script&lang=js&"
import style0 from "./coursewareTimeOut.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports